import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { debounce } from 'lodash-es';

import { MessageService } from '../../core/services/message.service';
import { PagingOptions } from '../../core/models/paged-options';
import { PagedList } from '../../core/models/paged-list';
import { Message } from '../../core/models/message';
import { MatTableDataSource } from '@angular/material/table';
import { MatButtonToggleChange } from '@angular/material/button-toggle';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { map, shareReplay } from 'rxjs';
import { MessageListService } from '../../core/services/message-list.service';
import { UrlTree, Router } from '@angular/router';
import { ClientService } from '../../core/services/client.service';

@Component({
  selector: 'app-messages',
  templateUrl: './messages.component.html',
  styleUrls: ['./messages.component.scss'],
})
export class MessagesComponent implements OnInit {

  loading = false;
  pagedMessages?: PagedList<Message> | undefined;
  pagedInboxMessages: PagedList<Message> | undefined;
  dataSource = new MatTableDataSource(this.pagedMessages?.items);
  search = new FormControl('');
  searchFilter = new FormControl('');
  searchTarget = new FormControl('subjectBody');
  private currentSearchFilter = '';
  
  defaultPagedRequest = { pageSize: 10, pageNumber: 1 };
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  unreadMessagesCount: number = 0;
  clientMatterContactDetails: any;

  constructor(private messageListService: MessageListService, private breakpointObserver: BreakpointObserver, private router: Router, private clientService : ClientService) {
   

  }

  ngOnInit(){

    this.getClientMatterContactDetails();

    this.messageListService.searchResult$.subscribe((results) => {
        this.pagedMessages = results;
         this.dataSource.data = results.items;
    });

    this.messageListService.loading$.subscribe((loading) => {
      this.loading = loading;
    });

    this.messageListService.unreadMessageCount$.subscribe((count) => {
      this.unreadMessagesCount = count;
    });

    //set initial values to kick of an initial search
    this.messageListService.searchTerm = '';
    this.messageListService.filters = {
      searchFilter: '',
      searchTarget: 'subjectBody'
    };
    this.messageListService.pagingRequest = { pageSize: 10, pageNumber: 1 };

     this.messageListService.getUnreadMessages();

   }

    getClientMatterContactDetails()
    {
      this.clientService.getClientMatterContactDetails().subscribe((val) => {
        this.clientMatterContactDetails = val;
      });
    }
    
  clearSearch() {
    this.search.setValue('');
    this.messageListService.searchTerm = '';
    this.messageListService.filters = {
      searchFilter: '',
      searchTarget: 'subjectBody'
    };
    this.messageListService.pagingRequest = { pageSize: 10, pageNumber: 1 };
  }
  
  handlePageEvent(e: PageEvent) {

    this.messageListService.pagingRequest = { pageSize: e.pageSize, pageNumber: e.pageIndex + 1 };
  
  }

  toggleFilter(event: MatButtonToggleChange, filterName: string) {
    if (this.currentSearchFilter === filterName) {
      this.searchFilter.setValue('');
      this.currentSearchFilter = '';
     
    }
    else{
      this.currentSearchFilter = filterName;
    }

    this.messageListService.filters = {
      searchFilter: this.currentSearchFilter,
      searchTarget: this.searchTarget.value ?? 'subjectBody'
    };

  }

  onSearchTermChange() {
    this.messageListService.searchTerm = this.search.value ?? '';
  }
  
  onSearchTargetChange() {
      this.messageListService.filters = {
      searchFilter: this.currentSearchFilter,
      searchTarget: this.searchTarget.value ?? 'subjectBody'
    };
    
  }

      getComposeMessageRouterLink() : UrlTree {
  
       return this.router.createUrlTree(['/message-compose'], { queryParams: { returnUrl: this.router.url } });
       
      }


}
